var FeedDataType = {
    TdsV1: { id: 1, name: "TdsV1", disabled: false, visible: true, selected: true, labelId: 'feed.datatype.tdsv1' },
    TdsV2: { id: 2, name: "TdsV2", disabled: true, visible: false, labelId: 'feed.datatype.tdsv2' },
    VolvoDynafleetTrackingDataV2: { id: 4, name: "VolvoDynafleetTrackingDataV2", disabled: true, labelId: 'feed.datatype.volvodynafleet' },
    Pvh: { id: 8, name: "Pvh", disabled: true, labelId: 'feed.datatype.pvh' },
    PvhLinkManualV1: { id: -1, name: "PvhLinkManualV1", disabled: true, labelId: 'feed.datatype.pvhmanual' },
    TdsV2VolvoCareTrack: { id: 11, name: "TdsV2VolvoCareTrack", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2' },
    TdsV2CatEntraId: { id: 15, name: "TdsV2CatEntraId", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2catentraid' },
    TdsV2Cat: { id: 12, name: "TdsV2Cat", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2cat' },
    TdsV2Hitachi: { id: 13, name: "TdsV2Hitachi", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2' },
    TdsV2Staad: { id: 14, name: "TdsV2Staad", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2' },
};
export function getFeedDataNameByValue(value) {
    var keys = Object.keys(FeedDataType);
    var found = keys.find(function (key) {
        return FeedDataType[key] === value;
    });
    return found != null ? found : value;
}
export default FeedDataType;
